module.exports = __webpack_public_path__ + "static/media/modal-close.7d1d77db.svg";